import { trackEvent as trackEventApi } from "@api/tracking.api";
import { AnalyticsEvent, ChatType } from "@common/constants/analytics-events";
import { UserSchema } from "@common/schemas/user.schema";

export function getAnalytics(): SegmentAnalytics.AnalyticsJS | undefined {
    return (window as any).analytics;
}

declare global {
    interface Window {
        _cio?: { identify: (params: CioIdentifyParams) => void };
    }
}

function getCio() {
    return window._cio;
}

interface CioIdentifyParams {
    id: number;
    client_id?: string;
}

export function identifyUser(user: UserSchema) {
    const [, gaCookie] = RegExp(/_ga=(.+?);/).exec(document.cookie) ?? [];
    const clientId = gaCookie?.split(".").slice(-2).join(".");

    const cioParams: CioIdentifyParams = {
        id: user.id,
    };

    if (clientId) {
        cioParams.client_id = clientId;
    }

    getAnalytics()?.identify(user.id);
    getCio()?.identify(cioParams);
}

export async function trackEvent(
    name: AnalyticsEvent,
    properties: Record<string, unknown> = {},
) {
    await trackEventApi(name, properties);
}

interface ChatEventParams {
    chatType: ChatType;
    properties?: Record<string, unknown>;
}

export function trackChatOpened({
    chatType,
    properties = {},
}: ChatEventParams) {
    void trackEvent(AnalyticsEvent.CHAT_OPENED, { chatType, ...properties });
}

export function trackChatClosed({
    chatType,
    properties = {},
}: ChatEventParams) {
    void trackEvent(AnalyticsEvent.CHAT_CLOSED, { chatType, ...properties });
}
